import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=963d7a2c&scoped=true&"
import script from "./Keywords.vue?vue&type=script&lang=ts&"
export * from "./Keywords.vue?vue&type=script&lang=ts&"
import style0 from "./Keywords.vue?vue&type=style&index=0&id=963d7a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963d7a2c",
  null
  
)

export default component.exports